import { useMemo } from "react";
import { useSelector } from "react-redux";
import WindowedSelect from "react-windowed-select";
import { filterDuplicates } from "../utils";
import searchIcon from "../../../assets/icons/search.svg";
const DynamicDropdown = ({ label, value, setValue, dataKey, placeholder }) => {
  const { blocks, racks, nonLGV, lgvs } = useSelector(
    (state) => state.inventory.items
  );

  const options = useMemo(() => {
    const merged = [...blocks, ...racks, ...nonLGV, ...lgvs];
    const uniqueValues = filterDuplicates(merged, dataKey);
    return uniqueValues.map((item) => ({
      label: item,
      value: item,
    }));
  }, [blocks, racks, nonLGV, lgvs, dataKey]);

  return (
    <div>
      <label className="field-label">{label}</label>
      {/* virtualizes the option*/}
      <div className="dropdown-wrapper">
        <img src={searchIcon} alt="search" className="search-icon" />
        <WindowedSelect
          isClearable
          options={options}
          placeholder={placeholder}
          value={value ? { value, label: value } : null}
          onChange={(item) => setValue(item?.value ?? null)}
          styles={{
            control: (base) => ({
              ...base,
              width: "100%",
              border: "none",
              boxShadow: "none",
              borderRadius: "10px",
            }),
            container: (base) => ({
              ...base,
              width: "100%",
              border: "none",
            }),
          }}
        />
      </div>
    </div>
  );
};

export default DynamicDropdown;
